"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.useButton = exports.getAbstractButtonProps = void 0;
const _composables_1 = require("../../_composables");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.getAbstractButtonProps = () => ({
    ..._composables_1.hasSizeProp,
    /**
     * Determines whether the `<button>` should be disabled.
     */
    disabled: {
        type: Boolean,
        required: false,
        default: false
    },
    /**
     * The theme of the `<button>`.
     */
    theme: {
        type: String,
        required: false,
        default: () => _composables_1.AbstractTheme.Default
    }
});
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.useButton = (emit, size, sizeRegistry, theme, themeRegistry) => {
    const onClick = () => { emit('click'); };
    const sizeClass = _composables_1.useSizeClass(size, sizeRegistry);
    const themeClass = _composables_1.useThemeClass(theme, themeRegistry);
    return { onClick, sizeClass, themeClass };
};
//# sourceMappingURL=Button.hooks.js.map